import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { IRequestForInformation } from "../../../api/RequestForInformation";
import EpaCard from "../../../leap-components/EpaCard";
import EpaField from "../../../leap-components/EpaField";
import EpaFieldHtml from "../../../leap-components/EpaFieldHtml";
import { GetLicenseeReturnPageUrl } from "../../routeFactory";

interface RequestForInformationDetailsProps {
  requestForInformation: IRequestForInformation;
}

const RequestForInformationDetails = ({
  requestForInformation,
}: RequestForInformationDetailsProps) => {
  const linkToLicenseeReturnDetails = GetLicenseeReturnPageUrl(
    requestForInformation.profileNo,
    requestForInformation.licenseesubmisionid
  );
  var bodyElements = (
    <div>
      <Row>
        <Col className="col-12 col-md-6">
          <EpaField
            label={"Date Issue by the EPA"}
            value={requestForInformation.datesubmitted}
          />
          <EpaField label={"Subject"} value={requestForInformation.subject} />
        </Col>
        <Col className="col-12 col-md-6">
          <EpaField
            label={"Licensee Response Due Date"}
            value={requestForInformation.duedate}
          />
          <EpaField
            label={"Related Licensee Return"}
            value={
              <Link to={linkToLicenseeReturnDetails}>
                {requestForInformation.licensee_return_reference}
              </Link>
            }
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-12">
          <EpaFieldHtml
            label={"Question from EPA"}
            value={requestForInformation.question}
            labelClassName={"col-12 col-md-12"}
            valueClassName={"col-12 col-md-12"}
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-md-6">
          <EpaField
            label={"Response Received Date"}
            value={requestForInformation.responsereceiveddate}
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-12">
          <EpaFieldHtml
            label={"Response from licensee"}
            value={requestForInformation.response}
            labelClassName={"col-12 col-md-12"}
            valueClassName={"col-12 col-md-12"}
          />
        </Col>
      </Row>
    </div>
  ) as JSX.Element;

  return (
    <EpaCard title={"Request for Information Details"} content={bodyElements} />
  );
};

export default RequestForInformationDetails;
